import { ArrowUpRight } from "lucide-react";

export default function Eduzy() {
  return (
    <section
      id="eduzy"
      data-testid="eduzy-section"
      className="ct-container scroll-mt-28 py-24 md:py-32"
    >
      <div className="grid items-stretch gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <span className="ct-eyebrow">Flagship Initiative</span>
          <h2 className="mt-4 font-display text-4xl font-bold leading-tight tracking-tight text-[#0F172A] sm:text-5xl">
            Eduzy — making quality
            <br />
            learning <span className="text-neutral-700">affordable & effective.</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600">
            <span className="font-semibold text-[#0F172A]">Eduzy</span> is the
            flagship learning initiative of{" "}
            <span className="font-semibold text-[#0F172A]">Contentium Tech</span>
            {" "}— owned and operated by us — designed to simplify how students,
            parents, and educators engage with knowledge. By pairing structured
            content with technology, Eduzy makes quality education accessible to
            a wider audience without the friction of traditional platforms.
            Contentium Tech is the legal entity behind Eduzy&apos;s operations,
            brand, and official communications, including its verified WhatsApp
            channel.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="https://eduzy.co"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="eduzy-visit-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#262626]"
            >
              Visit Eduzy
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-6 py-3 text-sm font-semibold text-[#0F172A] transition-colors hover:border-neutral-700 hover:text-neutral-700"
            >
              Partner with us
            </a>
          </div>
        </div>

        <div className="relative lg:col-span-5">
          <div className="absolute -inset-2 rounded-3xl bg-gradient-to-br from-neutral-100 to-transparent blur-2xl" />
          <div className="relative h-full overflow-hidden rounded-3xl border border-slate-200 bg-gradient-to-br from-white to-neutral-50/60 p-7">
            <div className="flex items-start justify-start">
              <div className="grid h-14 w-14 place-items-center rounded-xl bg-white ring-1 ring-neutral-200">
                <img
                  src="/brand/eduzy-logo.png"
                  alt="Eduzy"
                  className="h-11 w-11 object-contain"
                  draggable={false}
                />
              </div>
            </div>
            <h3 className="mt-7 font-display text-2xl font-semibold text-[#0F172A]">
              eduzy.co
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">
              Structured learning support, simplified.
            </p>

            <ul className="mt-7 space-y-3 text-sm">
              {[
                "Structured, scalable content",
                "Designed for affordability",
                "Built for parent + student trust",
                "DPDP-aligned, child-safe by design",
              ].map((t) => (
                <li
                  key={t}
                  className="flex items-start gap-2.5 rounded-xl border border-slate-200 bg-white px-4 py-3 text-[#0F172A]"
                >
                  <span className="mt-1 inline-block h-1.5 w-1.5 rounded-full bg-neutral-500" />
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
